import { render, staticRenderFns } from "./InterconsultaNueva.vue?vue&type=template&id=ff7d2996&"
import script from "./InterconsultaNueva.vue?vue&type=script&lang=js&"
export * from "./InterconsultaNueva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports